import { render, staticRenderFns } from "./endorsement.vue?vue&type=template&id=a7f02c32&scoped=true&"
import script from "./endorsement.vue?vue&type=script&lang=ts&"
export * from "./endorsement.vue?vue&type=script&lang=ts&"
import style0 from "./endorsement.vue?vue&type=style&index=0&id=a7f02c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f02c32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDivider,VImg})
